@if (block(); as block) {
  <article class="block-large-media container">
    <div class="row">
      <figure class="mb-3 col-md-24">
        @if (block.videoUrl) {
          <app-youtube class="d-block" [url]="block.videoUrl" [cookiePreferences]="cookiePreferences()" [inline]="true"></app-youtube>
        }
        @if (!block.videoUrl && block.image && block.image?.url) {
          <fstr-image class="d-block" [image]="block.image" [height]="1024" [width]="1920"></fstr-image>
        }
      </figure>
      <div class="col-md-14 offset-md-1">
        @if ((block.title || block.subtitle) && !block.hideTitle) {
          <header>
            @if (block.subtitle) {
              <strong class="fs-body-md fw-semi mb-2 text-primary d-inline-block w-100">{{ block.subtitle }}</strong>
            }
            @if (block.title) {
              <h2 class="h3 mb-0">
                {{ block.title }}
              </h2>
            }
          </header>
        }

        @if (block.text) {
          <div
            class="markdown-content mt-4"
            fstrDynamicContent
            [innerHTML]="block.text | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
          ></div>
        }

        @if (block.button?.url || block.secondaryButton?.url) {
          <footer class="mt-4 d-flex flex-wrap gap-2">
            @if (block.button?.url) {
              <fstr-link [button]="block.button!" [cssClasses]="'button button--primary'"></fstr-link>
            }
            @if (block.secondaryButton?.url) {
              <fstr-link [button]="block.secondaryButton!" [cssClasses]="'button button--primary-subtle'"></fstr-link>
            }
          </footer>
        }
      </div>
    </div>
  </article>
}
